import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppConfigModule } from './app-config.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';

import { UserChangePwdsModule } from '@app/modules/user-change-pwds/user-change-pwds.module';
import { UserChangePwdComponent } from '@app/modules/user-change-pwds/user-change-pwd/user-change-pwd.component';

import { UserProfilesModule } from 'usermanagement-boothelp/src/app/modules/user-profiles/user-profiles.module';
import { UserProfileComponent } from 'usermanagement-boothelp/src/app/modules/user-profiles/user-profile/user-profile.component';

import { AppConstant } from 'usermanagement-boothelp/src/app/_constant/app.constant';
import { Permissions } from 'usermanagement-boothelp/src/app/core/_tools/permissions';
import { AppConfig } from 'usermanagement-boothelp/src/app/app-config.module';

import { environment } from '@environments/environment';



// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './app.translate.factory';

import { Title } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import {register} from 'swiper/element/bundle';
import { NotificationAppConfig } from './shared/modules/notification/core/config/notification.config';

register();


export const APP_DI_CONFIG: AppConfig = {
  apiEndpoint: environment.apiEndpoint,
  apiTimeout: environment.apiTimeout,
  apiRetry: environment.apiRetry,
  runmode: environment.runmode,
  permissionCode: environment.permissionCode,
  group: environment.group,
  application: environment.application,
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    UserChangePwdsModule,
    UserProfilesModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppConfigModule,
    CoreModule,
    SharedModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [],
  entryComponents: [UserChangePwdComponent, UserProfileComponent],
  bootstrap: [AppComponent],
  providers: [
    Title,
    Permissions,
    AppConstant,
    BsModalService,
    BsModalRef,
    NgxPermissionsService,
    { provide: AppConfig, useValue: APP_DI_CONFIG },
    { provide: NotificationAppConfig, useValue: APP_DI_CONFIG },
    // { provide: APP_BASE_HREF, useValue: environment.baseHref }
  ],


})
export class AppModule {}
